import { 
  endOfDay, 
  endOfMonth, 
  endOfWeek, 
  format, 
  formatDistanceToNow, 
  isToday, 
  isYesterday, 
  parse, 
  parseISO, 
  startOfDay, 
  startOfMonth, 
  startOfWeek 
} from 'date-fns'

import { localeFormats } from 'shared/consts/localeFormats'
import { TFormatDateProps } from 'shared/types'

const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy'

const systemLanguage = navigator.language

const formatOptions = (withTime: boolean, shortYear?: boolean): any => ({
  year: shortYear ? '2-digit' : 'numeric',
  month: '2-digit',
  day: '2-digit',
  ...(withTime && { hour: '2-digit' }),
  ...(withTime && { minute: '2-digit' })
})

export const formatRange = (value: Date, type: 'week' | 'month') =>
  JSON.stringify({
    from: type === 'week' ? startOfWeek(value) : startOfMonth(new Date(value)),
    to: type === 'week' ? endOfWeek(value) : endOfMonth(new Date(value)),
    type
  })

export const formatCustomRange = (from: Date, to: Date, type: 'range') =>
  JSON.stringify({
    from: startOfDay(from),
    to: endOfDay(to),
    type
  })

export const weekPickerFormat = (value: Date) =>
  `${format(startOfWeek(new Date(value)), localeFormat())} - ${format(endOfWeek(new Date(value)), localeFormat())}`

export const monthPickerFormat = (value: Date) =>
  `${format(startOfMonth(value), localeFormat())} - ${format(endOfMonth((value)), localeFormat())}`

export const createCustomOption = (value: string) => {
  const { from, to, type } = JSON.parse(value)

  return {
    label: `${formatDate({date: from, withTime: false})} - ${formatDate({date:to, withTime: false})}`,
    value: JSON.stringify({from, to, type})
  }
}

export const parsePicker = ({ value }: any) => {
  const { from, to, type } = JSON.parse(value)
  return { from: new Date(from), to: new Date(to), type }
}
export const relativeDate = (date: string): string => 
  date ? `${formatDistanceToNow(new Date(date))} ago` : ''

export const formatDate = ({ date, withTime = true, locale = systemLanguage, shortYear }: TFormatDateProps): string => {
  if(!date) return ''
  const parsedDate = new Date(date)

  return parsedDate.toLocaleDateString(
    localeFormats[systemLanguage] ? locale : 'en',
    formatOptions(withTime, shortYear)
  )
}

export const formatConcertDate = (date: string): string => 
  format(parse(date, 'dd/mm/yyyy', new Date()), localeFormat())

export const localeFormat = () => localeFormats[systemLanguage] || DEFAULT_DATE_FORMAT

export const relativeDay = (date: string, withTime?: boolean): string => {
  switch (true) {
    case isToday(parseISO(date)):
      return 'Today'
    case isYesterday(parseISO(date)):
      return 'Yesterday'
    default:
      return formatDate({ date, withTime })
  }
}

export const formatNumberToIsoString = (date?: string): Date | string =>
  date && Number(date) ? new Date(Number(date)) : ''

export const formatNumberToDate = (date: string) =>
  formatDate({
    date: formatNumberToIsoString(date),
    withTime: false
  })
